module.exports = __webpack_public_path__ + "img/flow2.4d6d5456.png";